import user from './user/user.store';

export default {
    modules: {
        user
    },
};
